import styled from 'styled-components'

const MyDiv = styled.div`
.card{
box-shadow: 0px 0px 44px 0px rgba(0, 0, 0, 0.06);
border-radius:10px;
background-color: #fff;

}
.card-wrapper {
    border-radius: 10px;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.06);
    padding: 8px 8px 8px 8px;
    align-items: center;
    background-color: #F0F5F1;
  }
.tooltip {
  border-radius: 8px; 
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); 
  min-width: 200px;
  overflow: hidden;
  background-color: #fff;
}  
  }

.col{
    color:rgba(0, 0, 0, 1)
}   
}

.bg-border{
    background: #006838;
    height: 24px;
    width: 2px;
}
.react-calendar {
    font-family: 'Poppins', sans-serif;   
    width: 220px;
    max-width: 100%;
    font-size: 12px;
    border: none;
    border-radius: 8px;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.08);
}

.react-calendar__tile {
  padding: 6px 0;
}

.react-calendar__navigation button {
  min-width: 28px;
  font-size: 12px;
}
.react-calendar__month-view__days__day--weekend {
    color: #ff6b6b;
  }
`
export default MyDiv
